import axios from "axios";

/**
 * The kinds of failure a WSC request can produce. Callers use the kind to
 * decide how much to trust the failure: a 4xx is a definitive rejection, while
 * a dropped, timed-out, or otherwise unanswered request leaves the outcome
 * ambiguous and warrants reconciling against the server.
 * @readonly
 * @enum {string}
 */
export const WscErrorKind = Object.freeze({
  NETWORK: "network",
  HTTP_CLIENT: "http_client",
  HTTP_SERVER: "http_server",
  CANCELLED: "cancelled",
  UNKNOWN: "unknown",
});

/**
 * Classify an error thrown by a WSC request into a WscErrorKind.
 * @param {unknown} error The rejected value from an axios request
 * @returns {string} The matching WscErrorKind value
 */
export function classifyWscError(error) {
  if (axios.isCancel(error)) {
    return WscErrorKind.CANCELLED;
  }
  if (error?.response) {
    const status = error.response.status;
    return status >= 500 ? WscErrorKind.HTTP_SERVER : WscErrorKind.HTTP_CLIENT;
  }
  if (
    error?.request ||
    error?.code === "ECONNABORTED" ||
    error?.code === "ETIMEDOUT"
  ) {
    return WscErrorKind.NETWORK;
  }
  return WscErrorKind.UNKNOWN;
}
